<template>
    <div>
        <div class="otp-verificaitonWrap">
            <div class="container">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-5">
                        <div class="siteLogo mb-4">
                            <img src="https://corenroll-logo.s3.us-east-2.amazonaws.com/light-nuera.png"
                                class="img-fluid" alt="">
                        </div>
                        <div class="text-center">
                            <h2>OTP Verification</h2>
                            <p>Please type the OTP verification code displayed on enrollment confirmation.</p>
                            <div class="otpField">
                            <v-otp-input       @on-complete="onChangeOTP"
                                               @on-change="handleOnChange"
                                               ref="otpInput"
                                               separator=""
                                               :input-classes="errorClass"
                                               :num-inputs="6"
                                               :should-auto-focus="true"
                                               :disabled="isProcessing"
                                               :is-input-num="true"/>
                            </div>
                            <div class="valid-error" v-if="otpErrorFlag">
                              {{ otpErrorMsg }}
                            </div>
                            <button @click="verifyOtp">
                              <spinner-loader v-if="isProcessing"/>
                              Verify Code
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import OtpInput from '@bachdgvn/vue-otp-input';
import axios from "axios";
import SpinnerLoader from "@/components/SpinnerLoader";

export default {
    name: 'OtpVerification',
    components: {
      'v-otp-input': OtpInput,
      'spinner-loader': SpinnerLoader
    },
   data () {
     return {
       otp: "",
       errorClass : '',
       otpErrorFlag: false,
       isProcessing: false,
       errorMsg: '',
       otpErrorMsg: ''
     }
   },
    methods: {
      onChangeOTP(otp) {
        let app = this
        app.otp = otp
        app.verifyOtp();
      },
      handleOnChange (otp) {
        let app = this
        if (otp.length < 6) {
          app.otp = otp
        }
        if (app.otpErrorFlag) {
          app.otpErrorFlag = false
          app.errorClass = ''
          app.errorMsg = ''
        }
      },
      verifyOtp() {
        let app = this
        if ((!this.otp) || (this.otp.trim() === "")) {
          app.otpErrorFlag = true;
          app.errorClass = 'highlight_otp'
          app.otpErrorMsg = `Please enter  OTP inorder to proceed`;

        } else if ((app.otp.length < 6)) {
          app.otpErrorFlag = true;
          app.errorClass = 'highlight_otp'
          app.otpErrorMsg = "Please enter  6 digit OTP inorder to proceed";
        } else {
          app.errorClass = false
          app.isProcessing = true
          let params = {};
          params['otp'] = app.otp
          axios.post(process.env.VUE_APP_API_BASE + '/check-otp', params)
              .then((response) => {
                if (response.data.status == "success") {
                  let signatureRoute = response.data.data.short_url
                  app.$router.push(`${signatureRoute}`);
                  app.isProcessing = false
                }
              })
              .catch((error) => {
                app.errorClass = 'highlight_otp'

                if (error.response.data.status == "error") {
                  app.otpErrorFlag = true
                  app.otpErrorMsg = error.response.data.message
                  app.isProcessing = false
                }
              })
         }
      },
    },
};
</script>
<style>
.otpField input{
    width: 100%;
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 8px;
    outline: none;
    margin: 0 10px;
    text-align: center;
    margin-bottom: 1rem;
}
.otp-verificaitonWrap button{
    background: #3E7B98;
    width: 100%;
    color: #fff;
    border: 0;
    outline: none;
    padding: 15px 0;
    border-radius: 8px;
    margin-top: 1rem;
}
.otp-verificaitonWrap .row{
    min-height: 100vh;
}
.otp-verificaitonWrap h2{
    margin-bottom: 1rem;
    font-weight: 600;
}
.highlight_otp {
  border: 2px solid #e73737 !important;
}
.valid-error {
    padding: 10px;
    border-left: 3px solid #f00;
    border-radius: 8px;
    background: #fff0f0;
    color: #f00;
}
</style>